import { Image } from "antd";
import React, { useEffect, useState } from "react";
import config from "@/config";
import Confirm from "@/pages/job/components/Confirm";
import Fail from "@/pages/job/components/Fail";
import { useNavigate } from "react-router-dom";
import Success from "@/pages/job/components/Success";
import QRCode from 'qrcode';
import { FaMoneyBillWave, FaUsers, FaUserTie } from "react-icons/fa6";
import { FaMapMarkerAlt } from "react-icons/fa";


export const DetailJobTitleMB = ({ job }) => {
    const [visible, setVisible] = useState(false);
    const [isApply, setIsApply] = useState(true);
    const [isCv, setIsCv] = useState(true);
    const [visibleFail, setVisibleFail] = useState(false);
    const [visibleSuccess, setVisibleSuccess] = useState(false);

    const navigate = useNavigate();

    const handleConfirm = () => {
        setVisible(false);

        if (!isCv) {
            navigate(config.routes.resume)
        } else {
            if (isApply) {
                setVisibleSuccess(true);
            } else {
                setVisibleFail(true);
            }
        }
    }
    const handleClick = () => {
        setVisible(true);
    }
    const handleCloseConfirm = () => {
        setVisible(false);
    }
    const handleCloseFail = () => {
        setVisibleFail(false);
    }
    const handleCloseSuccess = () => {
        setVisibleSuccess(false);
    }

    const [QR, setQR] = useState();
    async function generateQRCodeBase64(url) {
        try {
            const qrBase64 = await QRCode.toDataURL(url, {
                color: {
                    dark: '#000000', // Màu QR
                    light: '#ffffff' // Màu nền
                }
            });
            return qrBase64;
        } catch (err) {
            console.error('Lỗi tạo QR code:', err);
            return null;
        }
    }

    // Gọi hàm và in kết quả
    useEffect(() => {
        generateQRCodeBase64(`https://vieclamsanxuat.vercel.app/${config.routes.job}/${job.Pk}`).then(qrImage => {
            setQR(qrImage)
        });
    }, [job]);




    return (
        <div className={"avatar w-full lg:w-1/3 items-center justify-center flex flex-col bg"}>
            <img
                src={'/' + job.Image || config.webConfig.defaultIcon}
                alt={job.JobTitle}
                className="border border-gray-5 lg:-mt-28 mt-25 lg:h-48 lg:w-48 h-32 w-32 shadow-xl aspect-square rounded-full"
            />
            <div className={"flex mt-2 lg:hidden flex-col items-center"}>
                <div className={"flex flex-col"}>
                    <h2 className="text-xl font-bold text-center">{job.JobTitle}</h2>
                    <p className="text-gray-500 text-lg">{job.JobCompanyName}</p>
                </div>
                <div className="w-full grid grid-cols-2 md:grid-cols-4  gap-1 mt-4">
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaMoneyBillWave className="w-full h-full text-primary" />
                        </div>
                        <h3 className="text-lg font-semibold text-center line-clamp-1">Thu nhập</h3>
                        <p className="w-full text-center line-clamp-1"> {job.JobSalary ? /^\d+$/.test(job.JobSalary) ? `${(+job.JobSalary).toLocaleString('vi-VN')}` : job.JobSalary : "Thỏa thuận"}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaMapMarkerAlt className="w-full h-full text-primary " />
                        </div>

                        <h3 className="text-lg font-semibold text-center line-clamp-1">Địa điểm</h3>
                        <p className="w-full text-center line-clamp-1"> {job.WorkPlace || "Liên Hệ"}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaUserTie className="w-full h-full text-primary " />
                        </div>
                        <h3 className="text-lg font-semibold text-center line-clamp-1">
                            Vị trí cần tuyển
                        </h3>
                        <p className="w-full text-center line-clamp-1"> {job.JobPosition || "Liên Hệ"}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaUsers className="w-full h-full text-primary " />
                        </div>
                        <h3 className="text-lg font-semibold text-center line-clamp-1">Số lượng cần tuyển</h3>
                        <p className="w-full text-center line-clamp-1"> {job.JobQuantity ? `${job.JobQuantity} người` : "Liên Hệ"}</p>
                    </div>
                </div>

            </div>
            <div className="container lg:mt-12 mt-4 flex flex-col md:flex-row lg:flex-col  justify-around gap-4 items-center ">
                <button
                    onClick={handleClick}
                    className=" !h-16 w-full bg-green-500 font-bold text-xl rounded-lg shadow-lg hover:shadow-xl hover:transition-colors border border-green-950 hover:bg-green-700 text-white"
                >
                    Ứng tuyển Ngay
                </button>
                <div className="flex xl:hidden gap-4 items-center">
                    <Image
                        width={120}
                        src={QR}
                        className="border border-gray-50 shadow-xl"
                    />
                    <a href={QR} download
                        className="text-cyan-400 mt-3 font-bold text-xl hover:underline hover:cursor-pointer">Tải
                        về</a>
                </div>
                <Confirm visible={visible} handleClick={handleConfirm} onClose={handleCloseConfirm} isApply={isApply} />
                <Fail visible={visibleFail} onClose={handleCloseFail} />
                <Success visible={visibleSuccess} onClose={handleCloseSuccess} />
            </div>
        </div>
    )
}